import React from 'react';
import PropTypes from 'prop-types';
import useMobileBreakpoint from '../../../../hooks/useMobileBreakpoint';
import EnrollmentProgressStepper from './EnrollmentProgressStepper';
import EnrollmentProgressCircle from './EnrollmentProgressCircle';

const EnrollmentProgress = ({ onBack }) => {
  const isMobile = useMobileBreakpoint();

  if (isMobile) {
    return <EnrollmentProgressCircle onBack={onBack} />;
  }

  return <EnrollmentProgressStepper onBack={onBack} />;
};

EnrollmentProgress.propTypes = {
  onBack: PropTypes.func.isRequired,
};

export default EnrollmentProgress;
